import { render, staticRenderFns } from "./DataCalendarioAcademico.vue?vue&type=template&id=61f5d92e"
import script from "./DataCalendarioAcademico.vue?vue&type=script&lang=js"
export * from "./DataCalendarioAcademico.vue?vue&type=script&lang=js"
import style0 from "./DataCalendarioAcademico.vue?vue&type=style&index=0&id=61f5d92e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports